import { api } from "../api.js";
import { useResource } from "../useResource.js";
import { Artist, type ArtistPayload } from "./Artist.js";
import { Failed, Loading } from "./Loading.js";

/**
 * The artist page, reading one artist.
 *
 * One request: the hero's score depends on every artist in the library (its rank is out of the
 * qualified ones), and the covers and songs are the evidence for it. Splitting them would paint
 * a score, then a rank, then a discography, in three steps.
 */
export function ArtistScreen({ artistId }: { artistId: number }) {
  const artist = useResource(() => api.get<ArtistPayload>(`/api/artists/${artistId}`), [artistId]);

  if (artist.error) return <Failed error={artist.error} retry={artist.reload} />;
  if (artist.loading || !artist.data) return <Loading what="the artist" />;

  // Remount on a different artist, so the songs tab does not carry over from the last one.
  return <Artist key={artist.data.artist.id} {...artist.data} />;
}
